import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {
    getConfiguration(cb) {
        axios.get('/umbraco/api/golf/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },

    getTeeTimes(payload, cb) {

        axios.post(getApiEndpoint() + 'api/golf/search', payload)
            .then(response => {
                cb(response.data);
            });
    },

    createBooking(payload, sessionId, cb) {
        axios.post(getApiEndpoint() + 'api/golf/' + sessionId + '/create', payload)
            .then(response => {
                cb(response.data);
            });

    },
    completeBooking(payload, sessionId, cb) {
        axios.post(getApiEndpoint() + 'api/golf/' + sessionId + '/complete', payload)
            .then(response => {
                cb(response.data);
            });

    }



}

